// JavaScript source code
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import Cart from '../components/cart';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import {  getUser,  getCart } from '../request';
import config from '../config';
import LoginDialog from '../components/loginDialog';

function Mall(props) {
    const activeIndex = 2;
    const authorization = localStorage.getItem("Authorization");
    var user = getUser();
    const showPrice = authorization != null && user != null && user.userType == 1 && user.business.businessStatus == 0;
    const [cartlist, setCartlist] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setShowLoading] = useState(false);
    const [isShowLogin, setIsShowLogin] = useState(false);
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    useEffect(() => {
        loadCart();

    }, []);
    const loadCart = () => {
        if (user != null && user.userType == 1 && user.business.businessStatus == 0) {
            setShowLoading(true);
            getCart().then(function (response) {
                setShowLoading(false);
                if (response.statusCode !== 200) {
                    localStorage.setItem('user', null);
                    return;
                }
                setCartlist(response.items.filter(function (c) { return c.sku; }));
            });
        }
    }
    return (      
        <div className="mall" >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="imgList" >
                    <Link to={`${config.root}/MallList?productType=3 `}>
                        <div className="img img1" ></div>
                    </Link>
                    <Link to={`${config.root}/MallList?productType=21 `}>
                        <div className="img img2" ></div>
                    </Link>
                    <Link to={`${config.root}/MallList?productType=23 `}>
                        <div className="img img3" ></div>
                    </Link>
                    <Link to={`${config.root}/MallList?productType=24 `}>
                        <div className="img img4" ></div>
                    </Link>
                    <Link to={`${config.root}/MallList?productType=25 `}>
                        <div className="img img5" ></div>
                    </Link>
                </div>
            </div>
            {
                showPrice &&
                <Cart num={cartlist.length} />
            }
            <SubFooter />
            <MessageDialog message={ errorMessage} onCancel={() => {
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
        </div>
          
    );
}

export default Mall;